import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import type { Module } from '@efdigital/ll-addon-data/types/xceed/module';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import {
  createRecord,
  findRecord,
  serializePatch,
  updateRecord,
} from '@warp-drive/utilities/json-api';

/**
 * Finds a module by id with its child content included
 * @param moduleId - The id of the module to find
 * @returns JSON API request to find the module with its child content included
 */
export function findModuleWithContent(moduleId: string) {
  return findRecord<Module>(DataTypeXceed.Module, moduleId, {
    ...jsonApiOptions,
    include: ['pages', 'quizzes', 'assessments', 'contacts'],
  } as FindRecordOptions);
}

/**
 * Creates a module
 * @param module - The module to create
 * @param store - The store to use
 * @returns JSON API request to create the module
 */
export function createModule(module: Module, store: Store) {
  const init = createRecord(module, {
    ...jsonApiOptions,
  });

  init.body = JSON.stringify({
    data: structuredClone(store.cache.peek(cacheKeyFor(module))),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}

/**
 * Updates a module
 * @param module - The module to update
 * @param store - The store to use
 * @returns JSON API request to update the module
 */
export function updateModule(module: Module, store: Store) {
  const init = updateRecord(module, {
    ...jsonApiOptions,
    patch: true,
  });

  init.body = JSON.stringify(serializePatch(store.cache, cacheKeyFor(module)));

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
